import { Injectable, Inject } from '@angular/core';
import { Router } from '@angular/router';
import { LOCAL_STORAGE } from '@ng-toolkit/universal';

@Injectable({
  providedIn: 'root',
})
export class LoginService {
  constructor(public router: Router, @Inject(LOCAL_STORAGE) private localStorage: any) {}

  // tslint:disable-next-line:variable-name
  public save(data: any, user_id: string): void {
    this.localStorage.setItem('user_id', user_id);
    this.localStorage.setItem('provider_uid', data.id);
    this.localStorage.setItem('provider_token', data.authToken);
    this.localStorage.setItem('first_name', data.firstName);
    this.localStorage.setItem('last_name', data.lastName);
    this.localStorage.setItem('image', data.photoUrl);
    this.localStorage.setItem('email', data.email);
    // ga('set', 'user_id', user_id);
    // ga('send', 'event', 'Login', 'user');
  }

  public isAuthenticated(): boolean {
    return (
      this.localStorage.getItem('user_id') !== null && this.localStorage.getItem('user_id') !== ''
    );
  }

  public getuser_id(): string {
    return this.localStorage.getItem('user_id');
  }

  public getLoginProvider(): string {
    return this.localStorage.getItem('_login_provider');
  }

  public getProvideruser_id(): string {
    return this.localStorage.getItem('provider_uid');
  }

  public getToken(): string {
    return this.localStorage.getItem('provider_token');
  }

  public getName(): string {
    return this.localStorage.getItem('first_name') + ' ' + this.localStorage.getItem('last_name');
  }

  public getFirstName(): string {
    return this.localStorage.getItem('first_name');
  }

  public getLastName(): string {
    return this.localStorage.getItem('last_name');
  }

  public getAvatar(): string {
    return this.localStorage.getItem('image');
  }

  public logout(): void {
    // Remove tokens and expiry time from this.localStorage
    this.localStorage.removeItem('user_id');
    this.localStorage.removeItem('provider_uid');
    this.localStorage.removeItem('provider_token');
    this.localStorage.removeItem('first_name');
    this.localStorage.removeItem('last_name');
    this.localStorage.removeItem('image');
    this.localStorage.removeItem('email');
    // Go back to the home route
    this.router.navigate(['/']);
    // ga('send', 'event', 'Logout', 'user');
  }
}
